// // src/contexts/ModuleContext.js
import React, { createContext, useCallback, useContext, useState } from "react";
import { fetchWithRetry } from "../utils/fetchWithRetry";

const ModuleContext = createContext();

export const ModuleProvider = ({ children }) => {
  const [modules, setModules] = useState([]);
  const [modulesLoading, setModulesLoading] = useState(false);
  const [modulesError, setModulesError] = useState(null);

  const fetchModules = useCallback(async () => {
    setModulesLoading(true); setModulesError(null);
    const ac = new AbortController();
    const url = `${process.env.REACT_APP_API_BASE_URL}/items/Module?fields=*.*`;
    try {
      const res = await fetchWithRetry(
        () => fetch(url, { signal: ac.signal }),
        { retries: 3, baseDelay: 300, signal: ac.signal }
      );
      if (!res.ok) throw new Error(`HTTP: ${res.status}`);
      const data = await res.json();
      setModules(data?.data ?? []);
    } catch (e) {
      if (!ac.signal.aborted) setModulesError("Ошибка при загрузке Modules!");
    } finally {
      if (!ac.signal.aborted) setModulesLoading(false);
    }
  }, []);

  return (
    <ModuleContext.Provider value={{ modules, modulesLoading, modulesError, fetchModules }}>
      {children}
    </ModuleContext.Provider>
  );
};

export const useModules = () => useContext(ModuleContext);
